import {
    Directive,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    NgZone,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges
} from '@angular/core';

import {ScreenService} from '../services';

@Directive({
    selector: '[swipeScroll]'
})
export class SwipeScrollDirective implements OnDestroy, OnChanges, OnInit {

    @Input() swipeContainer: HTMLElement;
    @Output() swiped = new EventEmitter<any>();

    offset = 0;
    resizeSubscription;

    constructor(private scrollWrapper: ElementRef, private screenService: ScreenService, private zone: NgZone) {
        this.resizeSubscription = this.screenService.addScreenResizedListener((viewport) => {
            this.fixPlacement();
        });
    }


    ngOnInit(): void {
        setTimeout(() => {
            this.fixPlacement();
        }, 100);
    }

    ngOnDestroy(): void {
        if (this.resizeSubscription) {
            this.resizeSubscription.unsubscribe();
        }
    }


    ngOnChanges(changes: SimpleChanges): void {

    }

    @HostListener('swipeleft', ['$event'])
    protected onSwipeLeft(event) {
        event.preventDefault();
        let scrollWidth = parseInt(window.getComputedStyle(this.swipeContainer).width);
        let wrapperWidth = parseInt(window.getComputedStyle(this.scrollWrapper.nativeElement).width);
        let width = scrollWidth - wrapperWidth;

        if (width <= 0) {
            this.offset = 0;
            return;
        }

        if (Math.abs(this.offset + event.deltaX) > width) {
            this.offset = -1 * width;
        } else {
            this.offset = this.offset + event.deltaX;
        }
        this.animate();
    }

    @HostListener('swiperight', ['$event'])
    protected onSwipeRight(event) {
        event.preventDefault();

        if (this.offset - event.deltaX < 0) {
            this.offset = 0;
            this.fixPlacement();
            return;
        } else {
            this.offset = this.offset - event.deltaX;
        }
        this.animate();
    }

    public fixPlacement() {
        try {
            let scrollWidth = parseInt(window.getComputedStyle(this.swipeContainer).width);
            let wrapperWidth = parseInt(window.getComputedStyle(this.scrollWrapper.nativeElement).width);
            if (scrollWidth - wrapperWidth <= 0) {
                this.offset = (wrapperWidth / 2 - scrollWidth / 2);
            } else {
                this.offset = 0;
            }
            this.swipeContainer.style.left = '0';
            this.swipeContainer.style.transform = 'translate(' + this.offset + 'px)';
        } catch (e) {
            console.error(e);
        }

    }

    private animate() {
        try {
            this.swipeContainer.style.transform = 'translate(' + this.offset + 'px)';
        } catch (e) {
            console.log(e);
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/common/directives/swipe-scroll.directive.ts